module.exports = __webpack_public_path__ + "media/sprinkles/sparkles-yellow-300-f7384be9.svg";